<template>
  <div class="width-100 minHeight position_relative" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" selectTab="0" style="min-width: 1200px"></tab>
    <!--    <div v-if="show" class="img3" style="width: 100%">-->
    <!--      <page1></page1>-->
    <!--    </div>-->
    <div class="swiper-container zIndex0">
      <div class="swiper-wrapper">
        <div class="swiper-slide" style="">
          <page1></page1>
        </div>
        <div class="swiper-slide" style="">
          <page2 :animation2="animation2"></page2>
        </div>
        <div class="swiper-slide">
          <page3 :animation2="animation3"></page3>
        </div>
        <div class="swiper-slide">
          <page5 :animation2="animation4"></page5>
        </div>
        <!--        <div class="swiper-slide">-->
        <!--          <page4  :animation2="animation5"></page4>-->

        <!--        </div>-->
      </div>
      <div class="swiper-button-next"></div>
    </div>

    <div class="fixed_r flex-column justify-content-center align-items-center">
      <span :class="currentPage === 0 ? 'circle_active' : ''" class="circle myBgBlue"></span>
      <span :class="currentPage === 1 ? 'circle_active' : ''" class="circle myBgBlue"></span>
      <span :class="currentPage === 2 ? 'circle_active' : ''" class="circle myBgBlue"></span>
      <span :class="currentPage === 3 ? 'circle_active' : ''" class="circle myBgBlue"></span>
      <!--      <span :class="currentPage === 4 ? 'circle_active' : ''" class="circle myBgBlue"></span>-->
      <!--      <div class="position_relative">-->
      <!--        <img class="margin-bs" src="@/assets/image/page1_03.png" width="25" alt="" />-->
      <!--        <div class="tip flex-row justify-content-center align-items-center">-->
      <!--          <img-->
      <!--            width="70"-->
      <!--            height="70"-->
      <!--            src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.xjishu.com%2Fimg%2Fzl%2F2017%2F10%2F212257159687020.gif&refer=http%3A%2F%2Fimg.xjishu.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1644457617&t=68a19c06794a1396abe7688dd52f9076"-->
      <!--            alt=""-->
      <!--          />-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <img @click="scrollTop" src="@/assets/image/page1_06.png" width="25" alt="" />-->
    </div>
    <div class="width-100 textAlign-c arrow-box">
      <!--            <img v-if="currentPage===0" class="arrow" src="@/assets/image/arrow.png" width="30px" alt="" />-->
      <img @click="pageTurn(currentPage)" v-if="currentPage == 0" class="arrow" src="@/assets/image/arrow.png" alt="" />
      <img @click="pageTurn(currentPage)" v-if="currentPage == 2 || currentPage == 1" class="arrow" src="@/assets/image/arrow1.png" alt="" />
    </div>
    <!--    <div v-if="showFloat" class="float-img position_absolute">-->
    <!--      <p class="white" style="position: relative; left: 145px; top: 42px; font-size: 0.5rem" @click="showFloat = false">关闭</p>-->
    <!--      <img src="../../assets/image/00.png" width="200" class="" alt="" />-->
    <!--    </div>-->
  </div>
</template>
<script>
// Import Swiper Vue.js components
// import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';

// Import Swiper styles
// import 'swiper/swiper-bundle.min.css';

import Swiper from 'swiper';
import page1 from '@/components/page1.vue';
import page2 from '@/components/page2.vue';
import page3 from '@/components/page3.vue';
// import page4 from '@/components/page4.vue';
import page5 from '@/components/page5.vue';
import tab from '@/components/tab.vue';
// import footerBox from '@/components/footer.vue';

export default {
  name: 'Index',
  components: {
    page1,
    page2,
    page3,
    // page4,
    page5,
    tab
    // footerBox
  },
  data() {
    return {
      showFloat: true,
      currentPage: 0,
      show: true,
      animation: true,
      animation2: false,
      animation3: false,
      animation4: false,
      animation5: false
    };
  },
  created() {
    // 移动端跳转至微网站
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      window.location.href = 'http://www.ragtjt.com/wx/#/';
    }
  },
  mounted() {
    let that = this;
    new Swiper('.swiper-container', {
      direction: 'vertical',
      autoHeight: true,
      // initialSlide:this.currentPage,
      mousewheel: true,
      navigation: {
        nextEl: '.swiper-button-next'
      },
      on: {
        slideChange: function () {
          that.currentPage = this.activeIndex;
          // console.log(that.currentPage);
          if (that.currentPage == 1) {
            that.animation = true;
            that.animation2 = true;
            that.animation3 = false;
            that.animation4 = false;
            that.animation5 = false;
          } else if (that.currentPage == 2) {
            that.animation = true;

            that.animation2 = false;
            that.animation3 = true;
            that.animation4 = false;
            that.animation5 = false;
          } else if (that.currentPage == 3) {
            that.animation = true;

            that.animation2 = false;
            that.animation3 = false;
            that.animation4 = true;
            that.animation5 = false;
          } else {
            that.animation = true;

            that.animation2 = false;
            that.animation3 = false;
            that.animation4 = false;
            that.animation5 = true;
          }
          // console.log(that.animation2);
        }
      }
    });
    setTimeout(function () {
      that.show = false;
    }, 8000);
  },
  methods: {
    scrollTop() {
      console.log('1');
      window.scrollTo(0, 0);
    },
    onSwiper(swiper) {
      console.log(swiper);
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    },
    pageTurn(e) {
      this.currentPage += 1;
      console.log(e);
    }
  }
};
</script>

<style lang="less" scoped>
*::-webkit-scrollbar {
  display: none;
}
.swiper-button-next {
  height: 80px;
  width: 2%;
  margin: 0 49%;
  position: fixed;
  top: 830px;
  opacity: 0;
  background: #86b4de;
  z-index: 9;
}
.img3 {
  position: absolute;
  z-index: 9;
  top: 0%;
  left: 0%;
  transform-origin: center;
  animation: my1 3s 5s ease-in-out;
  -moz-animation: my1 3s 5s ease-in-out; /* Firefox */
  -webkit-animation: my1 3s 5s ease-in-out; /* Safari and Chrome */
  -o-animation: my1 3s 5s ease-in-out; /* Opera */
}
@keyframes my1 {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}

@-moz-keyframes my1 /* Firefox */ {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}

@-webkit-keyframes my1 /* Safari and Chrome */ {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}

@-o-keyframes my1 /* Opera */ {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}
.swiper .swiper-slide:nth-child(2n) {
  height: 500px;
  line-height: 500px;
}
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
}
.swiper-slide2 {
  margin-bottom: 0 !important;
}
.swiper-container {
  height: 93vh;
  padding-top: 7vh;
  width: 100%;
  overflow: hidden;
}
.swiper-slide {
  width: 100%;
  height: 90vh;
  overflow-y: hidden;
}
.arrow {
  width: 30px;
}
.arrow-box {
  position: fixed;
  top: 830px;
  z-index: 0;
  display: inline-block;
}
.float-img {
  top: 100px;
  right: 5%;
  animation: myMove 60s infinite;
  -webkit-animation: myMove 60s infinite; /* Safari 和 Chrome */
}
@keyframes myMove {
  0% {
    top: 100px;
    right: 5%;
  }
  20% {
    top: 400px;
    right: 85%;
  }
  40% {
    top: 700px;
    right: 45%;
  }
  60% {
    top: 400px;
    right: 5%;
  }
  80% {
    top: 100px;
    right: 85%;
  }
  100% {
    top: 100px;
    right: 5%;
  }
}
</style>
